import React from "react";
import { Crumbs } from "molecules/Breadcrumbs";

const Overview = () => {
  return (
    <>
      <h2>Overview Page</h2>
    </>
  );
};

export default Overview;
